// @ts-nocheck
import { QueryClient } from '@tanstack/react-query';
import { OpenAPI } from 'gen/stream-api/requests/core/OpenAPI';
import { unauthorizedRedirectFallback } from 'util/unauthorizedRedirectFallback';
import { getOpenHouseToken } from 'util/user';
import { API_STREAM_HOST } from './shared';

OpenAPI.BASE = (import.meta.env.VITE_OPENAPI_STREAM_API_OVERRIDE ??
  (API_STREAM_HOST != null
    ? `https://${API_STREAM_HOST}`
    : 'http://localhost:3000')) as string;

Object.defineProperty(OpenAPI, 'TOKEN', {
  get: () =>
    (import.meta.env.VITE_OPENAPI_STREAM_API_TOKEN_OVERRIDE ??
      localStorage.sgToken) as string | undefined,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: true,
    },
  },
});

OpenAPI.interceptors.request.use((req: RequestInit) => {
  const ohToken = getOpenHouseToken();
  if (ohToken != null) {
    (req.headers as Headers)?.set('x-open-house-token', ohToken);
  }
  return req;
});

// automatically resolve application/octet-stream response.blob() into
// arrayBuffer to keep all async fetching code within the useQuery's async fetch
// block
OpenAPI.interceptors.response.use((rsp: Response): Response => {
  if (rsp?.status === 401) {
    unauthorizedRedirectFallback();
  }
  if (
    rsp?.status !== 204 &&
    (rsp?.headers.get('Content-Type')?.includes('application/octet-stream') ??
      false)
  ) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    rsp.blob = rsp.arrayBuffer;
  }
  return rsp;
});
